import React from 'react';
import { connect } from 'react-redux';

const ConnectedSlideNav = ({ fullpageApi, slideStatus, fullpageState }) => {
  const nextSlide = e => {
    e.preventDefault();
    fullpageApi.moveSectionDown();
  };

  const prevSlide = e => {
    e.preventDefault();
    fullpageApi.moveSectionUp();
  };

  const NavButton = ({ direction, hide = false }) => (
    <button
      aria-label={`${direction == 'prev' ? 'Prev' : 'Next'} Question`}
      className={`fullpage__nav-button ${
        direction == 'prev' ? 'prev' : 'next'
      }`}
      onClick={direction == 'prev' ? prevSlide : nextSlide}
      style={{
        opacity: hide ? 0 : 1,
      }}
    >
      {direction == 'prev' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            fill="#ffffff"
            d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            fill="#ffffff"
            d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
          />
        </svg>
      )}
    </button>
  );

  const NavButtons = ({ fullpageState }) => {
    return (
      <>
        <NavButton
          direction="prev"
          hide={fullpageState.destination.index == 0}
        />
        <NavButton
          direction="next"
          hide={
            fullpageState.destination.isLast ||
            !slideStatus[fullpageState.destination.index].completed
          }
        />
      </>
    );
  };

  return (
    <div className="fullpage__nav-group">
      {fullpageState.origin && <NavButtons fullpageState={fullpageState} />}
    </div>
  );
};

const mapStateToProps = state => {
  return state;
};

const SlideNav = connect(mapStateToProps)(ConnectedSlideNav);

export default SlideNav;
